import FeaturedArticles from './FeaturedArticles';

export default FeaturedArticles;
